import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';

/**
 * @description Sets the location type(s) from an array. ie; [city, zipcode]
 * @param searchParams
 * @param rawLocationTypes
 */
export const setRawLocationTypes = (
  searchParams: URLSearchParams,
  rawLocationTypes?: string[]
): void => {
  if (rawLocationTypes?.length) {
    rawLocationTypes.forEach((locationType) => {
      searchParams.append(searchFilterKeysMap.rawLocationTypes, locationType);
    });
  }
};
